export const ITEM_POSITIONS = {
  current: "current",
  previous: "previous",
  next: "next"
}

export const ITEM_TYPES = {
  linkedin_post: "linkedin_post",
  facebook_video: "facebook_video",
  prezi: "prezi",
  youtube: "youtube",
  oembed: "oembed",
  wistia: "wistia",
  google: "google",
  link: "link",
  pdf: "pdf",
  snapshot: "snapshot",
  video: "video",
  vidyard: "vidyard",
  image: "image",
  brighttalk: "brighttalk",
  brightcove: "brightcove",
  file: "file",
  box: "box",
  article: "article"
}